import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex flex-col items-center justify-center text-center px-4 py-20">
        <span className="w-20 h-20 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-6">
          <i className="ri-film-line text-4xl"></i>
        </span>
        <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">404</h1>
        <p className="text-foreground-600 mb-8">抱歉，您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 h-11 px-7 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-medium transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className="ri-home-4-line"></i>
          返回首页
        </Link>
      </main>
      <SiteFooter />
    </div>
  );
}